// Labels and small helpers shared by the campaign screens (Phase 8.9).
export const CHANNELS = ["push", "whatsapp", "sms", "email"];
export const CHANNEL_LABEL = { push: "Push and inbox", whatsapp: "WhatsApp", sms: "SMS", email: "Email" };
export const CHANNEL_SHORT = { push: "Push", whatsapp: "WhatsApp", sms: "SMS", email: "Email" };

export const STATUS_LABEL = { draft: "Draft", scheduled: "Scheduled", running: "Sending", paused: "Paused", completed: "Completed", cancelled: "Cancelled" };
export const STATUS_CLASS = {
    draft: "bg-secondary-subtle text-secondary",
    scheduled: "bg-info-subtle text-info-emphasis",
    running: "bg-primary-subtle text-primary",
    paused: "bg-warning-subtle text-warning-emphasis",
    completed: "bg-success-subtle text-success",
    cancelled: "bg-danger-subtle text-danger",
};
// The shared status chip's tone for each status (Kit StatusChip, R8).
export const STATUS_TONE = { draft: "neutral", scheduled: "info", running: "own", paused: "wait", completed: "ok", cancelled: "bad" };
export const EDITABLE = ["draft", "scheduled", "paused"];

// Rules the audience step offers (common-core Campaigns/Audience.js).
export const CUSTOMER_RULES = [
    { field: "all", label: "Everyone", kind: "none" },
    { field: "kyc", label: "KYC status", kind: "kyc" },
    { field: "documentExpiring", label: "Licence or passport expiring within (days)", kind: "days" },
    { field: "neverBooked", label: "Never booked", kind: "none" },
    { field: "bookedWithinDays", label: "Booked in the last (days)", kind: "days" },
    { field: "inactiveDays", label: "No trip for (days)", kind: "days" },
    { field: "tripCount", label: "Number of trips", kind: "range" },
    { field: "pendingBalance", label: "Has a balance to pay", kind: "none" },
    { field: "cancelledWithinDays", label: "Cancelled in the last (days)", kind: "days" },
    { field: "hub", label: "Booked at hub", kind: "hubs" },
    { field: "city", label: "Booked in city", kind: "cities" },
];
export const STAFF_RULES = [
    { field: "all", label: "All active staff", kind: "none" },
    { field: "hub", label: "Hub", kind: "hubs" },
    { field: "role", label: "Role", kind: "roles" },
    { field: "department", label: "Department", kind: "departments" },
];
export const KYC_LABEL = { verified: "Verified", incomplete: "Not finished", pending_review: "Waiting for review", rejected: "Rejected", expired: "Expired" };

export const TRIGGER_LABEL = { inactive_days: "No trip for N days", signup_no_kyc: "Signed up N days ago, KYC not done", after_trip: "N days after a trip" };
export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// Shown to people: the reasons someone was left out (Consent.REASONS gives most of the words).
export const REASON_LABEL = {
    opted_out: "Switched this channel off", no_device: "No phone or browser registered for push", no_phone: "No valid mobile number",
    no_whatsapp_consent: "Has not agreed to WhatsApp messages", no_marketing_consent: "Has not agreed to offers and promotions",
    no_email: "No email address", email_not_verified: "Email address not verified", not_for_staff: "Staff get campaigns by push only",
    no_channel: "Can't be reached on any chosen channel", duplicate: "Already in this run", shadow: "Shadow run: built, not sent",
    campaign_cancelled: "The campaign was cancelled", template_off: "Wording switched off", missing_data: "A value in the wording was empty",
};
export const reasonText = (code) => REASON_LABEL[code] || String(code || "").replace(/_/g, " ");

export const whenText = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit", hour12: true });
};
export const rupees = (value) => `Rs ${Number(value || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const pct = (part, whole) => (whole > 0 ? `${Math.round((Number(part || 0) / whole) * 100)}%` : "-");

// "Weekly on Mon, Thu at 10:00" etc.
export const scheduleText = (schedule = {}) => {
    const r = schedule.recurrence || {};
    if (schedule.type === "now") return "Send now";
    if (schedule.type === "once") return `Once, ${whenText(schedule.at)}`;
    if (schedule.type === "recurring") {
        const days = r.freq === "weekly" ? ` on ${(r.byDay || []).map((d) => DAY_NAMES[d]).join(", ")}` : r.freq === "monthly" ? ` on day ${(r.byDay || []).join(", ")}` : "";
        return `${r.freq ? r.freq.charAt(0).toUpperCase() + r.freq.slice(1) : "Recurring"}${days} at ${r.time || "-"}${schedule.endsAt ? `, until ${whenText(schedule.endsAt)}` : ""}`;
    }
    if (schedule.type === "trigger") {
        const t = schedule.trigger || {};
        return `${(TRIGGER_LABEL[t.event] || "Trigger").replace("N", t.days ?? "N")}${t.coolDownDays ? `, again after ${t.coolDownDays} days` : ", once per person"}`;
    }
    return "-";
};

export const errorsText = (result) => (result?.data?.errors || []).map((e) => e.message).join(" ") || result?.message;
